export const LinkTypes = {
  FETCH_LINKS: "FETCH_LINKS",
  SET_LINKS: "SET_LINKS",
  SET_MULTIGAME_ENABLED: "SET_MULTIGAME_ENABLED",
  SET_GAME_PROVIDER_IMAGES_ENABLED: "SET_GAME_PROVIDER_IMAGES_ENABLED",
  PREFERENCES_FETCH_SUCCESS: "PREFERENCES_FETCH_SUCCESS"
};
